var VoucherService = function (APIService) {
    var self = this;

    /**
     * Creates the voucher request template
     * @returns {promise}
     */
    self.GetVoucherRequestTemplate = function () {
        return APIService.Vouchers.GetVoucherRequestTemplate();
    };
};

angular.module('dashboard')
    .service('VoucherService', ['APIService',  VoucherService]);